module.exports = __webpack_public_path__ + "img/9788932911861.f7dd49ae.jpg";